<template>
  <router-view />
</template>

<style lang="scss" src="./index.scss"></style>
